<template>
  <transition name="fade">
    <div v-if="active" class="modal-overlay" @click.self="close">
      <div class="modal-container" style="margin-top: 20vh">
        <div class="modal-header">
          <span>Salesman location maps</span>
          <button class="close-btn" @click="close">x</button>
        </div>
        <div class="modal-body">
          <div
              v-if="mapData.isOutOfRange !== null"
              class="radius-status"
              :class="mapData.isOutOfRange ? 'status-outside' : 'status-inside'"
          >
            <span v-if="mapData.isOutOfRange" class="status-icon">⚠️</span>
            <span v-else class="status-icon">✅</span>
            <span class="status-text">
                {{ mapData.isOutOfRange ? "Out of Radius" : "In Radius" }}
              </span>
          </div>
          <div class="vx-row mb-3 mt-6">
            <div class="vx-col md:w-1/3">
              <div class="modal-container">
                <div class="modal-header">
                  <span>Visit Photo</span>
                </div>
                <div class="modal-body">
                  <div class="vx-row items-center" v-for="(tr, i) in fileAttachment" :key="i">
                    <div class="vx-col md:w-2/3">
                      <img :src="urlFile(tr)" style="width: 200px; height: 200px; object-fit: cover;" class="max-w-sm" @click="openPreview(i)" alt="">
                    </div>
                    <div class="vx-col md:w-1/3 flex justify-end">
                      <vs-button
                          type="line"
                          icon-pack="feather"
                          icon="icon-download"
                          :disabled="!tr.PathFile"
                          @click.stop="download(tr)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-2/3">
<!--              <MapViewer-->
<!--                    :latitude="mapData.latitude"-->
<!--                    :longitude="mapData.longitude"-->
<!--                    :accuracy="mapData.accuracy"-->
<!--                    :timestamp="mapData.timeStamp"-->
<!--                    :address="null"-->
<!--                    :height="'500'"-->
<!--                    :customer-location="mapData.customerLocation"-->
<!--                    :distance-between-customer-and-visit="distanceBetweenCustomerAndVisit"-->
<!--                />-->
              <RouteMapViewer
                  :customer-information="mapData.customerInformation"
                  :sales-information="mapData.salesInformation"
                  :height="'500'"
                  :route-color="'#3b82f6'"
                  :route-weight="4"
                  :timestamp="mapData.timeStamp"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import MapViewer from "@/components/MapViewer.vue";
import RouteMapViewer from "@/components/RouteMapViewer.vue";

export default {
  components: {
    MapViewer,
    RouteMapViewer,
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    fileAttachment: {
      type: Array,
      default: () => []
    },
    mapData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      index: 0,
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleEsc);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEsc);
  },
  methods: {
    close() {
      this.$emit('close')
    },
    openPreview(index){
      this.index = index
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    download(tr) {
      const link = document.createElement('a')
      link.href = tr.PathFile
      link.download = tr.NameFile
      link.click()
    },
    handleEsc(e) {
      if (e.key === 'Escape') {
        this.close()
      }
    },
    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
  },
  computed: {
    urlFile: () => {
      return (tr) => {
        return tr.File instanceof Blob ? URL.createObjectURL(tr.File) : tr.PathFile
      }
    },
    distanceBetweenCustomerAndVisit() {
      // Hitung jarak dari customer master data ke GPS visit actual
      const customerLat = this.mapData.customerLocation.latitude;
      const customerLng = this.mapData.customerLocation.longitude;
      const visitLat = this.mapData.latitude; // origin adalah visit GPS actual
      const visitLng = this.mapData.longitude;

      // Validasi data
      if (
          customerLat === null ||
          customerLng === null ||
          visitLat === null ||
          visitLng === null ||
          isNaN(customerLat) ||
          isNaN(customerLng) ||
          isNaN(visitLat) ||
          isNaN(visitLng)
      ) {
        return null;
      }

      // Haversine formula untuk menghitung jarak
      const R = 6371; // Earth's radius in kilometers
      const dLat = this.deg2rad(visitLat - customerLat);
      const dLon = this.deg2rad(visitLng - customerLng);
      const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(this.deg2rad(customerLat)) *
          Math.cos(this.deg2rad(visitLat)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c;

      // Return dalam meter jika < 1km, kilometer jika >= 1km
      if (distance < 1) {
        return `${(distance * 1000).toFixed(2)} m`;
      }
      return `${distance.toFixed(2)} km`;
    },
  },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-container {
  background: white;
  border-radius: 10px;
  width: 90%;
  max-height: 75vh;
  overflow: auto;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  transform: scale(1);
  transition: all 0.3s ease;
}

.fade-enter .modal-container {
  transform: scale(0.9);
  opacity: 0;
}

.fade-enter-to .modal-container {
  transform: scale(1);
  opacity: 1;
}

.fade-leave-active .modal-container {
  transform: scale(0.9);
  opacity: 0;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #eee;
  font-weight: bold;
}

.close-btn {
  border: none;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
}

.modal-body {
  padding: 10px;
}

.preview-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  cursor: pointer;
}

/* Radius Status Indicator */
.radius-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  margin: 0 16px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.radius-status.status-inside {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 1px solid #6ee7b7;
  color: #065f46;
}

.radius-status.status-outside {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: 1px solid #fca5a5;
  color: #991b1b;
}

.radius-status .status-icon {
  font-size: 18px;
  display: flex;
  align-items: center;
}

.radius-status .status-text {
  flex: 1;
  letter-spacing: 0.3px;
}
</style>